import { createContext, useContext, useEffect, useState } from "react";
import { api, readToken, writeToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = readToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    writeToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    writeToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    // Best-effort: invalida el token en el servidor (ver token_valid_after en
    // el backend) sin bloquear el logout local -- si la llamada falla (ya sin
    // red, token ya vencido), la sesión local se limpia de todos modos.
    api.post("/auth/logout").catch(() => {});
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
